// src/store/slices/lessonSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LessonItemType } from '../../remote/types/responses';

interface LessonState {
    lessons: Record<number, LessonItemType[]>;
    loading: boolean;
    error: string | null;
}

const initialState: LessonState = {
    lessons: {},
    loading: false,
    error: null,
};

const lessonSlice = createSlice({
    name: 'lesson',
    initialState,
    reducers: {
        fetchLessonsStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchLessonsSuccess(state, action: PayloadAction<{ courseId: number; lessons: LessonItemType[] }>) {
            const { courseId, lessons } = action.payload;
            state.lessons[courseId] = lessons;
            state.loading = false;
        },
        fetchLessonsFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchLessonsStart, fetchLessonsSuccess, fetchLessonsFailure } = lessonSlice.actions;
export default lessonSlice.reducer;
